import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './utils';
import type { ScanData } from './types';

export const scanApi = createApi({
  reducerPath: 'scanApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    fetchScans: builder.query<ScanData[], void>({
      query: () => ({
        url: `/v1/scan/`,
      }),
    }),
  }),
});

export const { useFetchScansQuery } = scanApi;

export const resetScanApiState = scanApi.util.resetApiState;
